/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb55Inputs */

const en__field_enum_pbs_fb55 = /** @type {(inputs: _Field_Enum_Pbs_Fb55Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 05 Faculty of Psychology and Sports Sciences`)
};

const de__field_enum_pbs_fb55 = /** @type {(inputs: _Field_Enum_Pbs_Fb55Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 05 Psychologie und Sportwissenschaften`)
};

/**
* | output |
* | --- |
* | "F 05 Faculty of Psychology and Sports Sciences" |
*
* @param {_Field_Enum_Pbs_Fb55Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb55 = /** @type {((inputs?: _Field_Enum_Pbs_Fb55Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb55Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb55(inputs)
	return de__field_enum_pbs_fb55(inputs)
});
export { _field_enum_pbs_fb55 as "_field_enum_PBS_FB5" }